/* ═══════════════════════════════════════════════
   LE CELLIER MORVANDIAU, Theme JS
   ═══════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  // ── Hamburger menu ──
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      hamburger.classList.toggle('open');
      mobileMenu.classList.toggle('open');
    });
  }

  // ── Active nav link ──
  var currentPath = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(function (a) {
    if (a.getAttribute('href') && currentPath.includes(a.getAttribute('href')) && a.getAttribute('href') !== '/') {
      a.classList.add('active');
    }
  });

  // ── Cart count from Shopify ──
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var el = document.querySelector('.cart-count');
      if (el) el.textContent = '(' + cart.item_count + ')';
    })
    .catch(function () {});

  // ── Add to cart ──
  var addToCartForms = document.querySelectorAll('.product-form-js');
  addToCartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('.product-add-btn');
      var originalText = btn.textContent;
      btn.textContent = 'Ajout en cours…';
      btn.disabled = true;

      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓ Ajouté au panier';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var el = document.querySelector('.cart-count');
              if (el) el.textContent = '(' + cart.item_count + ')';
            });
        })
        .catch(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });

  // ── Newsletter form ──
  var newsletterForms = document.querySelectorAll('.newsletter-form');
  newsletterForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('.newsletter-input');
      var btn = form.querySelector('.newsletter-btn');
      if (input && input.value) {
        btn.textContent = '✓ Inscrit !';
        input.value = '';
        setTimeout(function () { btn.textContent = "S'inscrire"; }, 3000);
      }
    });
  });

  // ── Mobile filter toggle (collection page) ──
  var filterToggle = document.getElementById('filter-toggle');
  var sidebar = document.querySelector('.collection-sidebar');
  if (filterToggle && sidebar) {
    function checkFilterBtn() {
      if (window.innerWidth <= 480) {
        filterToggle.style.display = 'flex';
      } else {
        filterToggle.style.display = 'none';
        sidebar.classList.remove('open');
      }
    }
    checkFilterBtn();
    window.addEventListener('resize', checkFilterBtn);
    filterToggle.addEventListener('click', function () {
      sidebar.classList.toggle('open');
      filterToggle.textContent = sidebar.classList.contains('open') ? '✕ Fermer' : '☰ Filtres';
    });
  }

});
